import { useFormik } from 'formik';
import { ChangeEvent, useEffect, useState } from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import { Button, Card, CardBody, Container, Form, FormGroup, Label } from 'reactstrap';
import { InputField } from 'src/components';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { useGetMidTermPassedTraineeListQuery } from 'src/rtk/features/midTerm/midTermApi';
import loader from '../../assets/images/loader.gif';

const MidTermPassedTrainees = () => {

    let referenceUrl = new URLSearchParams(location.search).get('ref');
    const [sessionName, setSessionName] = useState("");
    const [sessionYear, setSessionYear] = useState("");

    useEffect(() => {
        const today = new Date();
        const month = today.getMonth() + 1; // getMonth() returns 0–11
        const year = today.getFullYear();

        if (month >= 7 && month <= 12) {
            // July - December
            setSessionName("July-December");
            setSessionYear(year.toString());
        } else {
            // January - June
            setSessionName("January-June");
            setSessionYear((year - 1).toString());
        }
    }, []);

    const sessionList: SelectOption[] =
        [
            { value: 'January-June', label: 'January-June' },
            { value: 'July-December', label: 'July-December' },
        ];

    const year: SelectOption[] = Array.from(
        { length: new Date().getFullYear() - 2025 + 1 },
        (_, index) => {
            const value = (2025 + index).toString();
            return { value, label: value };
        }
    );


    const [page, setPage] = useState<any>(1);
    const [limit, setLimit] = useState<any>(10);
    const [search, setSearch] = useState('');

    const generateQueryUrl = () => {
        return `page=${page}&paginate_per_page=${limit}${search}&session_name=${sessionName}&session_year=${sessionYear}`;
    };

    const handlePageChange = (page: number) => {
        setPage(page);
    };

    const handlePerRowsChange = (newPerPage: number, page: number) => {
        setLimit(newPerPage);
        setPage(page);
    };

    const {
        data: passedTraineeList,
        isSuccess,
        isLoading,
        isFetching,
        refetch
    } = useGetMidTermPassedTraineeListQuery(generateQueryUrl());


    useEffect(() => {
        refetch();
    }, [referenceUrl]);

    interface SearchFields {
        search?: string;
        session_name?: string;
        session_year?: string;
        bmdc_registration_no?: string;
    }

    const initialValues: SearchFields = {
        search: '',
        session_name: '',
        session_year: '',
        bmdc_registration_no: '',
    };

    const {
        handleSubmit,
        getFieldProps,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        resetForm,
        setFieldValue,
        setErrors,
    } = useFormik({
        initialValues,

        onSubmit: (values: any) => {
            let s: string = '';

            if (values.search !== '') {
                s = s + `&search=${values.search}`;
            }

            // if (values.session_name !== '') {
            //     s = s + `&session_name=${values.session_name}`;
            // }

            // if (values.session_year !== '') {
            //     s = s + `&session_year=${values.session_year}`;
            // }
            if (values.bmdc_registration_no !== '') {
                s = s + `&bmdc_registration_no=${values.bmdc_registration_no}`;
            }

            setSearch(s);
            setPage('1');
            console.log(values);
        },
    });

    const columns: TableColumn<any>[] = [
        {
            name: <div>Sl. No.</div>,
            cell: (row, index) => <strong>{((page - 1) * limit + index) + 1}</strong>,
            width: '80px',
        },

        {
            name: <div>Name</div>,
            selector: (row) => row?.personal_info?.full_name,
            sortable: false,
            wrap: true,
        },
        {
            name: <div>BMDC Reg. No</div>,
            selector: (row) => row?.bmdc_registration_no,
            sortable: false,
        },

        {
            name: <div>Result</div>,
            selector: (row) => row?.mid_term_result,
            cell: (row) => {
                switch (row?.mid_term_result) {

                    case 'pass':
                        return (
                            <div className="badge rounded-pill d-inline-block  badge-approved font-size-12 fw-medium">
                                {'Pass'}
                            </div>
                        );

                    case 'fail':
                        return (
                            <div className="badge rounded-pill d-inline-block  badge-rejected font-size-12 fw-medium">
                                {'Fail'}
                            </div>
                        );

                    default:
                        return (
                            <div className="badge rounded-pill d-inline-block  badge-draft font-size-12 fw-medium">
                                {row?.mid_term_result || 'N/A'}
                            </div>
                        );
                }
            },
            sortable: false,
        }
    ];



    return (
        <div className="page-content">
            {isLoading || isFetching ? (
                <div className="overlay">
                    <img src={loader} alt="Loading" height={100} width={300} />
                </div>
            ) : null}
            <Container fluid>
                <BetterBreadcrumb
                    breadcrumbItem={[{ link: '#', name: 'Admin' }]}
                    title={'Mid Term Passed Trainees'}
                />
                <Card>
                    <CardBody>
                        <Form
                            className="custom-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                            onReset={(e) => {
                                e.preventDefault();
                                handleSubmit();
                                resetForm();
                            }}
                        >
                            <div className="filter-wrapper">
                                <FormGroup>
                                    <Label for="bmdc_registration_no">BMDC Reg. No</Label>
                                    <InputField
                                        type="text"
                                        placeholder="BMDC Reg. No"
                                        {...getFieldProps('bmdc_registration_no')}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="session_name">Session</Label>
                                    <InputField
                                        name='session_name'
                                        type="select"
                                        placeholder="Session"
                                        options={sessionList}
                                        onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                                            setSessionName(e.target.value);
                                        }}
                                        value={sessionName}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="session_year">Year</Label>
                                    <InputField
                                        type="select"
                                        placeholder="Year"
                                        options={year}
                                        name='session_year'
                                        onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                                            setSessionYear(e.target.value);
                                        }}
                                        value={sessionYear}
                                    />
                                </FormGroup>

                                <FormGroup className="btn-column mb-3">
                                    <Button color="warning" type="reset" outline>Reset</Button>
                                    <Button type="submit" color='primary'>Search</Button>
                                </FormGroup>
                            </div>
                        </Form>

                        <DataTable
                            columns={columns}
                            data={passedTraineeList?.data!}
                            pagination
                            paginationServer
                            progressPending={isLoading}
                            expandOnRowClicked
                            highlightOnHover
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handlePerRowsChange}
                            paginationRowsPerPageOptions={[2, 5, 10, 20, 50, 100, 200]}
                            responsive
                            persistTableHead={true}
                        />
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default MidTermPassedTrainees;
